/**
 * @generated SignedSource<<bbe8fd12e8131ddd6ae8d691431f7a9b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CustomerAccountsCard_brand$data = {
  readonly shopifyConfig: {
    readonly customerAuthenticationClientId: string | null;
    readonly isNewCustomerAccountsEnabled: boolean;
    readonly shopifyUrl: string;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"useBrandUpdateMutation_brand">;
  readonly " $fragmentType": "CustomerAccountsCard_brand";
};
export type CustomerAccountsCard_brand$key = {
  readonly " $data"?: CustomerAccountsCard_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"CustomerAccountsCard_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CustomerAccountsCard_brand",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useBrandUpdateMutation_brand"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandShopifyConfigType",
      "kind": "LinkedField",
      "name": "shopifyConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shopifyUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isNewCustomerAccountsEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customerAuthenticationClientId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "6eb160ee6944425c35af03f182d1abfe";

export default node;
